import { CookiesName } from '@/api';
import { useCookies } from 'vue3-cookies';
import { TLoginApiResponse } from '@/types/users';

const { cookies } = useCookies();

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(v) || 'Please enter a valid email address';
  },
  required: (v: any) => !!v || v === 0 || 'This field is required',
};

export const setAllCookies = (response: TLoginApiResponse) => {
  cookies.set(CookiesName.token, response.jsonWebToken);
  cookies.set(CookiesName.refreshToken, response.refreshToken);
  cookies.set(CookiesName.tokenExpiresAt, response.jsonWebTokenExpiresAt);
  cookies.set(
    CookiesName.refreshTokenExpiresAt,
    response.refreshTokenExpiresAt,
  );
};

export const tokenIsValid = () => {
  const token = cookies.get(CookiesName.token);
  const tokenExpiresAt = cookies.get(CookiesName.tokenExpiresAt);
  return (
    !!token &&
    !!tokenExpiresAt &&
    new Date(tokenExpiresAt).getTime() > Date.now()
  );
};

export const refreshTokenIsValid = () => {
  const token = cookies.get(CookiesName.refreshToken);
  const tokenExpiresAt = cookies.get(CookiesName.refreshTokenExpiresAt);
  return (
    !!token &&
    !!tokenExpiresAt &&
    new Date(tokenExpiresAt).getTime() > Date.now()
  );
};

export const getTomorrow = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
};
